import { Button, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { formatDateRange } from "../../../utils/date";
import type { DateRange } from "../../../types/date";

export type DateRangePickerFooterProps = {
  dateRange: Partial<DateRange>;
  onSubmit?: () => void;
};

export const DateRangePickerFooter = ({
  dateRange: { startDate, endDate },
  onSubmit = () => {},
}: DateRangePickerFooterProps) => {
  const i18n = useI18n();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mixin={{ paddingBlockStart: 2, paddingBlockEnd: 2 }}
    >
      <Text variant="emphasized_2">{startDate && formatDateRange(startDate, endDate)}</Text>
      <Button
        type="submit"
        size="large"
        text={i18n.trans(t("flights_airline_portal_airline_view_page_overall_date_picker_button"))}
        disabled={!startDate || !endDate}
        onClick={onSubmit}
      />
    </Stack>
  );
};
